import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { PatientGuarantor } from "pwapi";

import FlatResourceLine from "./FlatResourceLine";

type GuarantorLineProps = {
  guarantor: PatientGuarantor;
  onEditGuarantor?: Function;
};

const GuarantorLine = ({ guarantor, onEditGuarantor }: GuarantorLineProps) => {
  return (
    <FlatResourceLine resource={guarantor} onEdit={onEditGuarantor}>
      <span>
        Relationship to Patient:{" "}
        {guarantor.relationship_to_patient ? (
          guarantor.relationship_to_patient
        ) : (
          <span style={{ color: "var(--imperialRed)" }}>
            <FontAwesomeIcon icon="exclamation-circle" /> Missing Relationship
          </span>
        )}
        <br />
        {guarantor.last_name}, {guarantor.first_name} {guarantor.middle_initial}
        {guarantor.address && (
          <>
            <br />
            {guarantor.address.street}
            {guarantor.address.street2 && <>, {guarantor.address.street2}</>}
            <br />
            {guarantor.address.city}, {guarantor.address.state}{" "}
            {guarantor.address.zipcode}
          </>
        )}
      </span>
    </FlatResourceLine>
  );
};

export default GuarantorLine;
